(function(Manogi, $, undefined) {
    
    //Public

    Manogi.openModal = function(new_params) {
        $modal = $('.modal').first();
        var params = {
            show_cancel : true,
            show_confirm : false,
            confirm_text : $modal.find('.modal__button[data-mode=confirm]').data('default'),
            cancel_text : $modal.find('.modal__button[data-mode=cancel]').data('default'),
            message : '',
            form : '',
            confirm_action : function() { Manogi.closeModal(); },
            cancel_action : function() { Manogi.closeModal(); }
        };
        if(new_params){
            $.each(params, function(key,val){
                if(typeof new_params[key] !== "undefined"){
                    params[key] = new_params[key];
                }
            })
        }
        
        $modal.find('.modal__message').html(params['message']);
        $modal.find('.modal__form').html(params['form']);
        $modal.find('.modal__button[data-mode=confirm]').text(params['confirm_text']);
        $modal.find('.modal__button[data-mode=cancel]').text(params['cancel_text']);
        $modal.find('.modal__button[data-mode=confirm]').hide();
        $modal.find('.modal__button[data-mode=cancel]').hide();
        if(params['show_confirm']){
            $modal.find('.modal__button[data-mode=confirm]').show();
        }
        if(params['show_cancel']){
            $modal.find('.modal__button[data-mode=cancel]').show();
        }
        if(params['show_confirm'] || params['show_cancel']){
            $modal.find('.modal__buttons').show();
        }
        else{
            $modal.find('.modal__buttons').hide();
        }
        $modal.css({height:'100%'}).addClass('modal--open');
        $modal.find('.modal__button[data-mode=cancel]').unbind();
        $modal.find('.modal__button[data-mode=confirm]').unbind();
        $modal.find('.modal__button[data-mode=cancel]').on('click', function(){
            params['cancel_action']();
        });
        $modal.find('.modal__button[data-mode=confirm]').on('click', function(){
            params['confirm_action']();
        });
        Manogi.fixBody();
   };

    Manogi.closeModal = function() {
        $modal = $('.modal').first();
        $modal.removeClass('modal--open');
        window.setTimeout(function(){ $modal.css({height:0}); }, 700);
        
        Manogi.unfixBody();
    };


}( window.Manogi = window.Manogi || {}, jQuery ));